import React, { useMemo } from "react";
import { Button } from "nectar-ui";
import { NormalText } from "@components/styles/dataDisplay";
import { extractPlainText, sanitizeDescription } from "@pages/LawsuitPage/helper";

const HistoricalDescription = ({
  eventDescription = "",
  openModal,
}: {
  eventDescription?: string;
  openModal: () => void;
}) => {
  const sanitized = useMemo(() => sanitizeDescription(eventDescription), [eventDescription]);
  const plainText = useMemo(() => extractPlainText(sanitized), [sanitized]);

  if (!eventDescription) return null;

  const MAX_CHARS = 130;
  const shouldOpenModal = plainText.length > MAX_CHARS;

  if (shouldOpenModal) {
    return (
      <div style={{ display: "flex", columnGap: 4, flexWrap: "wrap", alignItems: "flex-end" }}>
        <NormalText id="description">{plainText.substring(0, 127).concat("...")}</NormalText>
        <Button link onClick={openModal}>
          Ver mais
        </Button>
      </div>
    );
  }

  return <NormalText dangerouslySetInnerHTML={{ __html: sanitized }} />;
};

export default HistoricalDescription;
